import { render, staticRenderFns } from "./DepositSource.vue?vue&type=template&id=59640dc5&scoped=true"
import script from "./DepositSource.vue?vue&type=script&lang=js"
export * from "./DepositSource.vue?vue&type=script&lang=js"
import style0 from "./DepositSource.vue?vue&type=style&index=0&id=59640dc5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59640dc5",
  null
  
)

export default component.exports